module.exports = __webpack_public_path__ + "img/intro_sub_uk.81fe2e02.svg";